import React from 'react';
import styled from 'styled-components';
import Header from './components/Header';
import { ntvImages } from '../Theming/images';
import { themeColor } from '../Theming';
import { ANALYTICS_PAGE_NAMES, useIsIPad } from '../Common/Analytics/utils';
import { usePageViewTracking, useQuery } from '../Common/Hooks';
import { isAndroid } from 'react-device-detect';
import { onClose } from '../TIM/KindredAndroid';

const Container = styled.div<{ isIPad?: boolean }>`
  flex: 1;
  flex-direction: column;
  display: flex;
  max-height: 100dvh;
  width: 100vw;
  margin: 0 auto;

  & > img {
    width: 100%;
    margin-top: ${(props) => (props.isIPad ? '0' : '30px')};
  }
`;
const TextContainer = styled.div`
  padding-inline: 40px;
`;

const TitleText = styled.span<{ isIPad?: boolean }>`
  display: block;
  line-height: ${({ isIPad }) => (isIPad ? '42px' : '34px')};
  font-size: ${({ isIPad }) => (isIPad ? '32px' : '26px')};
`;

const Description = styled.span<{ isIPad?: boolean }>`
  font-weight: 400;
  font-size: ${({ isIPad }) => (isIPad ? '24px' : '18px')};
  line-height: ${({ isIPad }) => (isIPad ? '32px' : '24px')};
  display: block;
  margin-top: 24px;
`;

const BottomContent = styled.div<{ isIPad?: boolean }>`
  padding: 0 24px 34px 24px;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: center;
  flex: 1;

  & > a {
    color: #46555f;
    margin-top: 20px;
    font-size: ${({ isIPad }) => (isIPad ? '20px' : '16px')};
  }
`;

const Button = styled.button<{ isIPad?: boolean }>`
  background-color: #2d3c46;
  height: ${({ isIPad }) => (isIPad ? '70px' : '61px')};
  color: ${themeColor('white')};
  font-size: ${({ isIPad }) => (isIPad ? '24px' : '18px')};
  font-weight: 600;
  width: 100%;
  font-style: semi-bold;
`;

const NTVPluginActivationStartShopping = () => {
  const { activation_complete_page } = ANALYTICS_PAGE_NAMES;
  usePageViewTracking(activation_complete_page, 'NTV');
  const query = useQuery();
  const origin = query.get('origin');
  const isIPad = useIsIPad();

  const openNTVApp = () => {
    if (isAndroid) {
      return onClose();
    }
    window.location.href = `${origin}://`;
  };

  return (
    <Container isIPad={isIPad}>
      <Header
        logoWidth={51}
        height={283}
        text={
          <TextContainer>
            <TitleText isIPad={isIPad}>ntv Shopping Deals</TitleText>
            <TitleText isIPad={isIPad}>erfolgreich aktiviert</TitleText>
            <Description isIPad={isIPad}>
              Unser Popup erscheint, wenn wir passende Rabattcodes für Sie
              finden.
            </Description>
          </TextContainer>
        }
      />
      <img src={ntvImages.ntv_brands_white} alt="popular brands" />
      <BottomContent isIPad={isIPad}>
        <Button isIPad={isIPad} onClick={openNTVApp}>
          Zurück zur App
        </Button>
        <a
          target="_blank"
          href="https://event.kindred.co/ntv-faqs"
          rel="noreferrer"
          className="faq"
        >
          Häufig gestellte Fragen
        </a>
      </BottomContent>
    </Container>
  );
};

export default NTVPluginActivationStartShopping;
